
export function addButtonIcons( chevronButtons ) {
	// const chevronButtons = document.querySelectorAll('.wp-block-button .wp-block-button__link, .wp-element-button, .is-style-as-buttons .wp-block-navigation-item__label, a.is-style-arrow-right')
	if (chevronButtons) {
		chevronButtons.forEach(element => {

			// Only add if not there yet.
			if (!element.querySelector('.svg-icon')) {
				let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
				let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
				use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_chevron_right');
				svg.append(use)
				svg.classList.add('svg-icon')
				svg.setAttribute('aria-hidden', 'true')
				element.append(svg)
			}
		})
	}
}


export function addIcons() {
	// console.log('add the icons');

	// // Add External Links icons
	// const externalLinks = document.querySelectorAll('a[target="_blank"]')
	// if (externalLinks) {
	// 	externalLinks.forEach(element => {
	// 		let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
	// 		let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
	// 		use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#luca-external-link');
	// 		svg.append(use)
	// 		svg.classList.add('svg-icon')
	// 		svg.setAttribute('aria-hidden', 'true')
	// 		element.append(svg)
	// 	})
	// }

	// Add Button icons
	// const leesMeerButtons = document.querySelectorAll('.wp-block-button.is-style-arrow-right .wp-block-button__link, .wp-block-button.is-style-arrow-right .wp-element-button, .wp-block-button.is-style-back .wp-block-button__link, .wp-block-button.is-style-back .wp-element-button, .wp-block-query-pagination-next, .wp-block-query-pagination-previous')
	// if (leesMeerButtons) {
	// 	leesMeerButtons.forEach(element => {
	// 		let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
	// 		let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
	// 		use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_arrow_right');
	// 		svg.append(use)
	// 		svg.classList.add('svg-icon')
	// 		svg.setAttribute('aria-hidden', 'true')
	// 		element.append(svg)

	// 		// Is this a referrer button?
	// 		// Try to add the back link.
	// 		if (element.parentElement.classList.contains('is-referrer-link')) {
	// 			const referrer_URL = document.referrer
	// 			let referrer_href = '#'
	// 			// console.log( 'referrer: ' + referrer_URL )

	// 			if (referrer_URL) {
	// 				// Are we coming from the same site?
	// 				if ( referrer_URL.includes( 'inzet.be' ) || referrer_URL.includes( 'stg-inznd-staging2026.kinsta.cloud' ) || referrer_URL.includes( 'inzetstag.test' ) ) {
	// 					// And NOT from within the admin?
	// 					if ( ! referrer_URL.includes( '/wp-admin' ) ) {
	// 						referrer_href = referrer_URL
	// 					}
	// 				}
	// 			}
	// 			element.setAttribute('href', referrer_href)
	// 		}
	// 	})
	// }


	// Create SVG Echt INZET button.

	const echtInzetButtons = document.querySelectorAll('.btn--echt_inzet a, a.btn--echt_inzet')
	if (echtInzetButtons) {
		echtInzetButtons.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inzet_bubble');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}


	// ALL buttons will have a chevron. In a function, we'll need to re-add the icons on ajax calls too (filters).
	const chevronButtons = document.querySelectorAll('.wp-block-button .wp-block-button__link, .wp-element-button, .is-style-as-buttons .wp-block-navigation-item__label, a.is-style-arrow-right')
	addButtonIcons(chevronButtons)

	// const chevronButtons = document.querySelectorAll('.wp-block-button .wp-block-button__link, .wp-element-button, .is-style-as-buttons .wp-block-navigation-item__label, a.is-style-arrow-right')
	// if (chevronButtons) {
	// 	chevronButtons.forEach(element => {
	// 		let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
	// 		let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
	// 		use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_chevron_right');
	// 		svg.append(use)
	// 		svg.classList.add('svg-icon')
	// 		svg.setAttribute('aria-hidden', 'true')
	// 		element.append(svg)
	// 	})
	// }



	// Add List icons
	// .is - style - checkmarks
	// .is - style - favourites
	const checkmarkListItems = document.querySelectorAll('.wp-block-list.is-style-checkmarks > li')
	if (checkmarkListItems) {
		checkmarkListItems.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inzet_checkmark');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}

	const arrowListItems = document.querySelectorAll('.wp-block-list.is-style-arrows > li')
	if (arrowListItems) {
		arrowListItems.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inzet_arrow_list');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}

	const favListItems = document.querySelectorAll('.wp-block-list.is-style-favourites > li')
	if (favListItems) {
		favListItems.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_favoriet');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}


	// Add arrows to linked blocks
	const linkedGroupBlocks = document.querySelectorAll('.wp-block-group.is-linked')
	if (linkedGroupBlocks) {
		linkedGroupBlocks.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_arrow_right');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}


}


